<template>
  <div class="w3-margin">
    <div v-if="isNotRole" class="w3-text-red w3-large w3-center">
        Nincs jogosultsága a funkció használatáshoz!
    </div>
    <div v-else>
        <h4 class="page-title">FIZETÉSEK ADMINISZTRÁLÁSA</h4>  
        <div v-if="showEntry" class="w3-modal" style="z-index: 4000; display:block;">    
            <div class="w3-modal-content w3-card-4 w3-animate-zoom">
                <div class="w3-display-container">
                    <div class="w3-blue">
                        <h3 class="w3-padding">Nevezés kezelése</h3>
                    </div>
                    <div class="w3-row-padding">
                        <div class="w3-half w3-mobile">          
                            <div class="w3-margin-right w3-margin-top">
                                <label class="w3-text-blue">Email cím</label>
                                <input readonly v-model="aktEntry.email" class="w3-input w3-border">                         
                            </div>
                        </div>
                        <div class="w3-half w3-mobile">          
                            <div class="w3-margin-right w3-margin-top">
                                <label class="w3-text-blue">Számlázási név</label>
                                <input readonly v-model="aktEntry.invName" class="w3-input w3-border">                         
                            </div>
                        </div>
                        <div class="w3-half w3-mobile">          
                            <div class="w3-margin-right w3-margin-top">
                                <label class="w3-text-blue">Adószám</label>
                                <input readonly v-model="aktEntry.invVatNum" class="w3-input w3-border">                         
                            </div>
                        </div>
                        <div class="w3-half w3-mobile">          
                            <div class="w3-margin-right w3-margin-top">
                                <label class="w3-text-blue">Számlázási cím</label>
                                <input readonly v-model="aktEntry.invAddress" class="w3-input w3-border">                         
                            </div>
                        </div> 
                        <div class="w3-half w3-mobile">          
                            <div class="w3-margin-right w3-margin-top">
                                <label class="w3-text-blue">Név </label>
                                <input readonly v-model="aktEntry.userName" class="w3-input w3-border" >                         
                            </div>
                        </div>
                        <div class="w3-half w3-mobile">
                            <div class="w3-margin-right w3-margin-top">
                                <label class="w3-text-blue">Sorszám</label>
                                <input readonly v-model="aktEntry.id" class="w3-input w3-border">
                            </div>      
                        </div>
                        <div class="w3-half w3-mobile">          
                            <div class="w3-margin-right w3-margin-top">
                                <label class="w3-text-blue">Útvonal neve</label>
                                <input readonly v-model="aktEntry.hikeName" class="w3-input w3-border" >                         
                            </div>
                        </div>
                        <div class="w3-half w3-mobile">
                            <div class="w3-margin-right w3-margin-top">
                                <label class="w3-text-blue">Ár</label>
                                <input readonly v-model="aktEntry.price" class="w3-input w3-border">
                            </div>      
                        </div>
                        <div class="w3-half w3-mobile">          
                            <div class="w3-margin-right w3-margin-top">
                                <label class="w3-text-blue">Fizetés dátuma</label>
                                <input v-model="aktEntry.payDate" class="w3-input w3-border" type="date">                         
                            </div>
                        </div>
                        <div class="w3-half w3-mobile">          
                            <div class="w3-margin-right w3-margin-top">
                                <label class="w3-text-blue">Fizetés státusza</label>
                                <select v-model="aktEntry.status" class="w3-input w3-border">
                                    <option value=1>Nincs fizetve</option>
                                    <option value=2>Fizetve</option>
                                </select>
                            </div>
                        </div>               
                    </div>
                </div>
                <div class="w3-container w3-light-grey w3-padding w3-margin-top">
                    <button class="w3-button w3-border w3-border-green w3-right w3-green w3-hover-white w3-margin-left" v-on:click="updateEntry(aktEntry)">Mentés</button>
                    <button class="w3-button w3-border w3-border-blue w3-right w3-blue w3-hover-white w3-margin-left" v-on:click="cancelEntry(tmpAktEntry)">Mégsem</button>
                </div>
            </div> 
        </div>      
        <div class="">            
        <table v-if="entriesList" class="w3-table-all w3-small">
                <tr class="">
                    <td class="w3-large">
                        <font-awesome-icon icon="filter"></font-awesome-icon>                                                
                    </td>
                    <td>
                        <input class="w3-input w3-border" v-model="filter.id">
                    </td>
                    <td>
                        <input class="w3-input w3-border" v-model="filter.name">
                    </td>
                    <td class="w3-hide-small">
                    </td>
                    <td class="w3-hide-small">
                    </td>                  
                    <td class="w3-hide-small">
                    </td>                  
                    <td>
                        <select v-model="filter.status" class="w3-input w3-border">
                            <option value=-1></option>
                            <option v-for="(item, index) in $appData.payStatus" :key="index" v-bind:value="item.sign">{{item.name}}</option>
                        </select>
                    </td>
                </tr>                        
                <tr class="theme-1">
                    <td>#</td>
                    <td v-on:click="sortBy('id')" class="cursorpointer">
                        Azonosító
                        <font-awesome-icon v-if="sortKey=='id' && reverse=='desc'" icon="angle-up"></font-awesome-icon>
                        <font-awesome-icon v-if="sortKey=='id' && reverse=='asc'" icon="angle-down"></font-awesome-icon>                                                
                    </td>
                    <td v-on:click="sortBy('userName')" class="cursorpointer">
                        Név
                        <font-awesome-icon v-if="sortKey=='userName' && reverse=='desc'" icon="angle-up"></font-awesome-icon>
                        <font-awesome-icon v-if="sortKey=='userName' && reverse=='asc'" icon="angle-down"></font-awesome-icon>                                                
                    </td>
                    <td class="w3-hide-small w3-center cursorpointer" v-on:click="sortBy('creatDate')">
                        Dátum
                        <font-awesome-icon v-if="sortKey=='creatDate' && reverse=='desc'" icon="angle-up"></font-awesome-icon>
                        <font-awesome-icon v-if="sortKey=='creatDate' && reverse=='asc'" icon="angle-down"></font-awesome-icon>
                    </td>
                    <td v-on:click="sortBy('hikeName')" class="w3-hide-small w3-center cursorpointer">
                        Útvonal
                        <font-awesome-icon v-if="sortKey=='hikeName' && reverse=='desc'" icon="angle-up"></font-awesome-icon>
                        <font-awesome-icon v-if="sortKey=='hikeName' && reverse=='asc'" icon="angle-down"></font-awesome-icon>                                
                    </td> 
                    <td v-on:click="sortBy('price')"  class="w3-center w3-hide-small">
                        Ár
                        <font-awesome-icon v-if="sortKey=='price' && reverse=='desc'" icon="angle-up"></font-awesome-icon>
                        <font-awesome-icon v-if="sortKey=='price' && reverse=='asc'" icon="angle-down"></font-awesome-icon>                                
                    </td>                 
                    <td v-on:click="sortBy('status')" class="w3-center cursorpointer">
                        Státusz
                        <font-awesome-icon v-if="sortKey=='status' && reverse=='desc'" icon="angle-up"></font-awesome-icon>
                        <font-awesome-icon v-if="sortKey=='status' && reverse=='asc'" icon="angle-down"></font-awesome-icon>                                
                    </td>
                </tr>                                    
                <tr class="cursorpointer" v-on:click="editEntry(item)" v-for="(item, index) in orderedAndFilteredList" :key="index">
                    <td>{{index+1}}.</td>
                    <td>{{item.id}}</td>
                    <td>{{item.userName}}</td>
                    <td class="w3-hide-small w3-center">{{item.creatDate | filterDateFormat}}</td>
                    <td class="w3-hide-small w3-center">{{item.hikeName}}</td>   
                    <td class="w3-hide-small w3-center">{{item.price}} &euro;</td>                                        
                    <td class="w3-center">{{item.status | filterPaymentStatus}}</td>                                        
                </tr>
            </table>
        </div>
    </div>
  </div>
</template>

<script>
const fb = require('../firebase.js')
import "../filters.js";
export default {
     name: 'PaymentAdmin',
    data() {
        return {
            isNotRole:false,
            entriesList:null,
            sortKey: 'sumtime',
            reverse: 'asc',
            search: '',
            filter:{
                "id":"",
                "userName":"",
                "status":1,
                "hikeName":""
            },
            showEntry:false,
            aktEntry:null,
            tmpAktEntry:null
        }        
    },
     computed: {
        orderedAndFilteredList: function () {
            var orderedList=this.entriesList;
            if ((this.sortKey=="price") && (this.reverse=="asc"))                    
                orderedList=this.entriesList.slice().sort(function(a, b) {
                   if ((a.sumtime==0) || (b.sumtime==0)) {
                       return (b.sumtime-a.sumtime);
                   } else {                     
                       return a.sumtime - b.sumtime;
                   }
                });
            if ((this.sortKey=="price") && (this.reverse=="desc"))                    
                orderedList=this.entriesList.slice().sort(function(a, b) {
                   return b.sumtime - a.sumtime;
               });  
            if ((this.sortKey=="hikeName") && (this.reverse=="asc"))                    
                orderedList=this.entriesList.slice().sort(function(a, b) {
                    return a.hikeName.localeCompare(b.hikeName);
                });
            if ((this.sortKey=="hikeName") && (this.reverse=="desc"))                    
                orderedList=this.entriesList.slice().sort(function(a, b) {
                   return b.hikeName.localeCompare(a.hikeName);
            });               
             if ((this.sortKey=="id") && (this.reverse=="asc"))                    
                orderedList=this.entriesList.slice().sort(function(a, b) {
                    return a.id.localeCompare(b.id);
                });
            if ((this.sortKey=="id") && (this.reverse=="desc"))                    
                orderedList=this.entriesList.slice().sort(function(a, b) {
                   return b.id.localeCompare(a.id);
            });                             
           if ((this.sortKey=="creatDate") && (this.reverse=="asc"))                    
               orderedList=this.entriesList.slice().sort(function(a, b) {
                    return a.creatDate - b.creatDate;
               });
           if ((this.sortKey=="creatDate") && (this.reverse=="desc"))                    
               orderedList=this.entriesList.slice().sort(function(a, b) {
                   return b.creatDate - a.creatDate;
           });   
           if ((this.sortKey=="status") && (this.reverse=="asc"))                    
               orderedList=this.entriesList.slice().sort(function(a, b) {
                   return a.status - b.status;
               });
           if ((this.sortKey=="status") && (this.reverse=="desc"))                    
               orderedList=this.entriesList.slice().sort(function(a, b) {
                   return b.status - a.status;
           });    
           if ((this.sortKey)=='userName' && (this.reverse=='asc'))
           orderedList=this.entriesList.slice().sort(function(a, b) {
               return a.userName.localeCompare(b.userName);
           });
           if ((this.sortKey)=='userName' && (this.reverse=='desc'))
           orderedList=this.entriesList.slice().sort(function(a, b) {
               return b.userName.localeCompare(a.userName);
           });                                                                           
           var filteredList = orderedList.filter((item) => {
                const idFilter = (item.id.toLowerCase().indexOf(this.filter.id.toLowerCase())>-1);                        
                const nameFilter = (item.userName.toLowerCase().indexOf(this.filter.userName.toLowerCase())>-1);                        
                const statusFilter = (item.status==this.filter.status) || (this.filter.status==-1);                 
                return idFilter && nameFilter && statusFilter;
           });                        
           return filteredList;                               
        }
    },
    methods:{
        formatDate(d){
            var month = '' + (d.getMonth() + 1);
            var day = '' + d.getDate();
            var year = d.getFullYear();
            if (month.length < 2) 
                month = '0' + month;
            if (day.length < 2) 
                day = '0' + day;
            return [year, month, day].join('-');
        },
        updateEntry(item){
            fb.UpdateEntry(item).then(r=>{   
                this.$dialog.alert(this.$setDialogMsg('w3-green','Mentés','Sikeres mentés!')).then(r=>{                                           
                });
            }).catch(e=>{
                console.log(e);
                this.$dialog.alert(this.$setDialogMsg('w3-red','Mentés','Hiba történt a művelet során. Kérjük próbálkozzon újra!'));
            });
            this.showEntry=false;
        },
        cancelEntry(item){
            this.showEntry=false;
            this.getAllEntries();
        },
        editEntry(item){
            this.showEntry=true;
            this.aktEntry=item;
            var d = new Date();
            this.aktEntry.payDate=this.formatDate(d);
        },
        sortBy(sortKey) {
            if (this.sortKey == sortKey) {
                if (this.reverse=='asc') this.reverse='desc';
                else this.reverse='asc';
            };
            this.sortKey = sortKey;
        },
        getAllEntries(){
            this.$showSpinner();
            fb.GetAllEntries().then(r=>{   
                var eList=[];
                for (var e in r) {
                    eList.push(r[e]);
                }
                this.entriesList=eList;
                console.log(eList);
                this.$hideSpinner();
            }).catch(e=>{
                console.log(e);
                this.$hideSpinner();
            });
        },
    },
     created: function(){
        if (this.$store.getters.userProfile) {
            if (fb.IsPaymentAdmin(this.$store.getters.userProfile.uid)) this.getAllEntries();
            else this.isNotRole=true;
        } else {
            this.isNotRole=true;
        }
    }
}
</script>
